import { ReactNode, isValidElement } from "react";

export const typeChecker = (item?: string | number | Date | JSX.Element | ReactNode) => ({
  string: typeof item === 'string',
  number: typeof item === 'number',
  date: item instanceof Date,
  jsx: isValidElement(item),
  reactNode:isValidElement(item) || typeof item === 'string' || typeof item === 'number'
})